import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2k2a3zkrv0yyf as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.buffer_1.transferFrom_v29myr_k$($this.delegate_1.get_readBuffer_yjmj9b_k$());
  $this.initial_1 = add($this.initial_1, appended);
}
function updateConsumed($this) {
  $this.consumed_1 = add($this.consumed_1, subtract($this.initial_1, $this.buffer_1.get_size_woubt6_k$()));
  $this.initial_1 = $this.buffer_1.get_size_woubt6_k$();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.delegate_1 = delegate;
        this.buffer_1 = new (Buffer())();
        this.initial_1 = 0n;
        this.consumed_1 = 0n;
      }
      get_totalBytesRead_dai8jq_k$() {
        updateConsumed(this);
        return this.consumed_1;
      }
      get_closedCause_o1qcj8_k$() {
        return this.delegate_1.get_closedCause_o1qcj8_k$();
      }
      get_isClosedForRead_ajcc1s_k$() {
        return this.buffer_1.exhausted_p1jt55_k$() && this.delegate_1.get_isClosedForRead_ajcc1s_k$();
      }
      get_readBuffer_yjmj9b_k$() {
        transferFromDelegate(this);
        return this.buffer_1;
      }
      *awaitContent_q7m0p7_k$(min, $completion) {
        if (this.get_readBuffer_yjmj9b_k$().get_size_woubt6_k$() >= fromInt(min)) {
          return true;
        }
        if (yield* this.delegate_1.awaitContent_q7m0p7_k$(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      cancel_9i2dv0_k$(cause) {
        this.delegate_1.cancel_9i2dv0_k$(cause);
        this.buffer_1.close_yn9xrc_k$();
      }
    }
    protoOf($).awaitContent$default_rxihsg_k$ = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
